import { render, staticRenderFns } from "./CustomOpeningHour.vue?vue&type=template&id=7328c2d0&scoped=true"
import script from "./CustomOpeningHour.vue?vue&type=script&lang=js"
export * from "./CustomOpeningHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328c2d0",
  null
  
)

export default component.exports